import React from "react";
import _ from 'lodash';
import * as PostApi from './PostApi';
import PostConstants from './PostConstants';

import { successNotification } from '../notifications/NotificationActions';

const receivedPost = (post) => ({
    type: PostConstants.POST_RECEIVED,
    payload: post
});

const removedPost = (postId) => ({
    type: PostConstants.POST_REMOVED,
    payload: {
        id: postId,
    }
});

const sharedPost = (postId) => ({
    type: PostConstants.POST_SHARED,
    payload: {
        id: postId,
        published_at: (new Date()).toISOString().substring(0, 10),
    }
});

const scheduledPost = (postId, schedule) => ({
    type: PostConstants.POST_SCHEDULED,
    payload: {
        id: postId,
        schedule: schedule
    }
});

const unscheduledPost = (postId) => ({
    type: PostConstants.POST_UNSCHEDULED,
    payload: {
        id: postId
    }
});

const removedImage = (postId, image) => ({
    type: PostConstants.POST_REMOVED_IMAGE,
    payload: {
        id: postId,
        image: image
    }
});

export function listPosts(accountId) {
    return function (dispatch) {
        return PostApi.listPosts(accountId).then(response => {
            _.map(response, post => {
                dispatch(receivedPost(post));
            });

            return response;
        });
    };
}

export function getPost(postId) {
    return function (dispatch) {
        return PostApi.getPost(postId).then(post => {
            dispatch(receivedPost(post));

            return post;
        });
    };
}

export function createPost(postId, accountId, type) {
    return function (dispatch) {
        return PostApi.createPost(postId, accountId, type).then(response => {
            return dispatch(getPost(postId));
        });
    };
}

export function editPost(postId, message = undefined, media = undefined) {
    return function (dispatch) {
        return PostApi.editPost(postId, {message, media}).then(response => {
            return dispatch(getPost(postId));
        });
    };
}

export function editPostReply(postId, replyId, message) {
    return function (dispatch) {
        return PostApi.editPostReply(postId, replyId, message);
    };
}

export function editPostReplies(postId, replies) {
    return function (dispatch) {
        return PostApi.editPostReplies(postId, replies).then(response => {
            return dispatch(getPost(postId));
        });
    };
}

export function schedulePost(postId, schedule) {
    return function (dispatch) {
        dispatch(scheduledPost(postId, schedule));

        return PostApi.schedulePost(postId, schedule);
    };
}

export function unschedule(postId) {
    return function (dispatch) {
        return PostApi.unschedulePost(postId)
            .then(() => dispatch(unscheduledPost(postId)))
            .then(() => dispatch(successNotification('Post Unscheduled')));
    }
}

export function removeImage(postId, image) {
    return function (dispatch) {
        dispatch(removedImage(postId, image));

        return PostApi.removeImage(postId, image).then(() => {
            return dispatch(getPost(postId));
        });
    };
}

export function sharePost(postId) {
    return function (dispatch) {

        return PostApi.sharePost(postId)
            .then(() => dispatch(sharedPost(postId)))
            .then(() => dispatch(successNotification('Post Shared Successfully')));
    }
}

export function removePost(postId) {
    return function (dispatch) {
        dispatch(removedPost(postId));

        return PostApi.removePost(postId);
    }
}

export function removePostReply(postId, replyId) {
    return function (dispatch) {
        // dispatch(removedPostReply(postId, replyId)); -- should we add this?

        return PostApi.removePostReply(postId, replyId);
    }
}

export function removePostReplies(postId, replyIds) {
    return function (dispatch) {
        // dispatch(removedPostReply(postId, replyId)); -- should we add this?

        return PostApi.removePostReplies(postId, replyIds);
    }
}
